<template>
    <div class="RejectedWarp">
        <!-- 列表数据 -->
        <el-table :data="tableData" style="width: 100%" border :header-cell-style="tableHeaderColor">

            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="expertName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="expertType" label="专家类别" align="center"></el-table-column>
            <el-table-column prop="unit" label="所在单位" align="center"></el-table-column>
            <el-table-column prop="duty" label="职务" align="center"></el-table-column>
            <el-table-column prop="auditResult" label="驳回原因" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="auditResultbox">
                        {{scope.row.auditResult}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="驳回时间" align="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.auditTime |timer}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="240" fixed="right" align="center">
                <template slot-scope="scope">
                    <div class="handle_warp">
                        <div class="edit_box" @click="editNewsFn(scope.row)">修改</div>
                        <el-popconfirm icon="el-icon-info" icon-color="red" title="您确定删除当前专家信息？" @confirm='deteleNews(scope.row.expertId)' confirm-button-text='确定'
                            cancel-button-text='取消'>
                            <el-button slot="reference" class="delete_box">删除</el-button>
                        </el-popconfirm>

                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="paging_warp">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 15, 20]"
                :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    props: ['searchVal'],
    data() {
        return {
            tableData: [],
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 总条数
            total: 0,
            audit: 3,
            userId: '',
        }
    },
    watch: {
        searchVal: {
            handler: function (val, oldVal) {
                if (val) {
                    this.getList()
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        if (JSON.parse(sessionStorage.getItem('userInfo'))) {
            this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        // 获取列表
        async  getList() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                audit: this.audit,
                userId: this.userId,
                findAll: this.searchVal,
            };
            let data = await httpService.getbackstageExpertList(params);
            if (data.code == 200) {
                this.tableData = data.result.list
                this.total = data.result.total
            }
        },
        tableHeaderColor() {
            return "background-color:#FAFAFA;color:rgba(0,0,0,0.85);border-bottom:1px solid #FAFAFA;font-weight:900;height:55px";
        },
        // 分页
        async handleSizeChange(val) {
            this.pageSize = val;
            this.getList()
        },
        async handleCurrentChange(val) {
            this.currentPage = val;
            this.getList()
        },
        // 修改
        editNewsFn(data) {
            this.$emit('changeTab', { name: '信息创建' }, data.expertId, { tagName: '被驳回' });
        },
        // 删除
        deteleNews(id) {
            httpService.deletBusexpertById(id).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getList()
                }
            })
        }
    },
    filters: {
        timer: (value) => {
            if (value) {
                return value.substring(0, 10);
            }
        },
    },

}
</script>
<style lang="less" scoped>
.RejectedWarp {
  .handle_warp {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .edit_box {
      // font-size: 18px;
      color: #0083ff;
      cursor: pointer;
      margin: 0 10px;
    }
    .delete_box {
      // font-size: 18px;
      color: #f02e2e;
      cursor: pointer;
      margin: 0 10px;
    }
    /deep/.el-button {
      border: none;
      padding: 0;
    }
  }
  .paging_warp {
    text-align: center;
    position: fixed;
    bottom: 40px;
    left: 50%;
  }
  .auditResultbox {
    color: #f02e2e;
    cursor: pointer;
  }
}
</style>


